import { CartBulkItem, PaymentType } from "../core/global";
import { ApiResponse, err, postAxios, processError, res } from "./axios";

interface StripeCreateCheckoutSessionProps {
  processing_token: string
  payment_method: string
  organisation_id: string | number | null
  project_id: number | string | null
  tokens?: null | number
  purchase_tokens?: CartBulkItem[]
  address_book_id?: number | string | null
}

export const stripeCreateCheckoutSession = async ({
  processing_token,
  payment_method,
  organisation_id,
  project_id,
  tokens,
  purchase_tokens,
  address_book_id,
}: StripeCreateCheckoutSessionProps):Promise<ApiResponse> => {
  try {
    const result = await postAxios(`/api/v1/payment/stripe-create-checkout-session`, {
      processing_token,
      organisation_id, 
      payment_method,
      project_id,
      tokens,
      purchase_tokens,
      address_book_id,
    }, false)
    const response = result?.data || null
    return res(response)
  } catch (e) {
    const {status, message} = processError(e, "Error processing payment.")
    return err(message, status)
  }
}

interface ProcessCheckoutSessionProps {
  processing_token: string
  transaction_id: string
}


export const processCheckoutSession = async ({
  processing_token,
  transaction_id,
}: ProcessCheckoutSessionProps):Promise<ApiResponse> => {
  try {
    const result = await postAxios(`/api/v1/payment/process-checkout-session`, {
      processing_token,
      transaction_id,
    }, false)
    const response = result?.data || null
    return res(response)
  } catch (e) {
    const {status, message} = processError(e, "Error processing payment.")
    return err(message, status)
  }
}



interface ProcessCheckoutTokensSessionProps {
  processing_token: string
  transaction_id: string
  tokens: string | null
}


export const processCheckoutTokensSession = async ({
  processing_token,
  transaction_id,
  tokens,
}: ProcessCheckoutTokensSessionProps):Promise<ApiResponse> => {
  try {
    const result = await postAxios(`/api/v1/payment/process-checkout-tokens-session`, {
      processing_token,
      transaction_id,
      tokens,
    }, false)
    const response = result?.data || null
    return res(response)
  } catch (e) {
    const {status, message} = processError(e, "Error processing payment.")
    return err(message, status)
  }
}



interface ProcesSubscriptionOrderProps {
  processing_token: string
  payment_method: PaymentType
  organisation_id: string | number | null
  address_book_id?: number | string | null
}


export const processSubscriptionOrder = async ({
  processing_token,
  payment_method,
  organisation_id,
  address_book_id
}: ProcesSubscriptionOrderProps):Promise<ApiResponse> => {
  try {
    const result = await postAxios(`/api/v1/payment/process-subscription-order`, {
      processing_token,
      payment_method,
      organisation_id,
      address_book_id
    }, false)
    const response = result?.data || null
    return res(response)
  } catch (e) {
    const {status, message} = processError(e, "Error processing payment.")
    return err(message, status)
  }
}

interface ProcesOrderRequestProps {
  organisation_id: string | number | null
  notes?: string | null
  processing_token: string
}

export const processOrderRequest = async ({
  organisation_id,
  processing_token,
  notes
}: ProcesOrderRequestProps):Promise<ApiResponse> => {
  try {
    const result = await postAxios(`/api/v1/payment/process-order-request`, {
      organisation_id,
      processing_token,
      notes
    }, false)
    const response = result?.data || null
    return res(response)
  } catch (e) {
    const {status, message} = processError(e, "Error processing order request.")
    return err(message, status)
  }
}
